export const zIndex = {
  background: -1,
  favoritePastilleContent: 1,
  floatingButton: 1,
  header: 1,
  homeOfferCoverIcons: 1,
  modalHeader: 1,
  playlistButton: 1,
  progressbar: 1,
  headerNav: 2,
  progressbarIcon: 2,
  tabBar: 2,
  locationWidget: 2,
  cheatCodeButton: 50,
  snackbar: 50,
  bottomSheet: 60,
  // !!! Important !!! Whatever you do, you will never get something above a react-native modal
}
